module.exports = __webpack_public_path__ + "img/index_tree_2.540feb67.png";